// extracted by mini-css-extract-plugin
export default {"container":"LandingServices_container__W4Dqw","serviceImage1":"LandingServices_serviceImage1__bfD31","serviceImage2":"LandingServices_serviceImage2__tIjl+"};